const RoleState = {
    roles: [],
    permissions: [],
};

export default RoleState;